import { useContext } from "react";

import LaunchDarklyContext from "./launchDarklyProvider";

export const useRefreshLaunchDarklyFlags = () => {
  const { refreshFlags } = useContext(LaunchDarklyContext);

  return refreshFlags;
};
